var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('audio',{ref:"audio",attrs:{"src":(_vm.state.player_current_track != null && _vm.state.player_current_track < _vm.state.playlist.length) ? _vm.state.playlist[_vm.state.player_current_track][0] : ''},on:{"ended":_vm.onEnded,"timeupdate":_vm.onTimeUpdate,"loadedmetadata":_vm.onLoadedMetadata,"play":_vm.onPlay,"pause":_vm.onPause}})])
}
var staticRenderFns = []

export { render, staticRenderFns }